class ReviewsTestimonials extends HTMLElement {
    connectedCallback() {
      const tabBtns     = Array.from(this.querySelectorAll('.rt-tab-btn'));
      const panels      = Array.from(this.querySelectorAll('.rt-panel'));
      const initialized = new Array(panels.length).fill(false);
      const desktopLayout = this.dataset.desktopLayout;
  
      const initSwiper = (panel) => {
        new Swiper(panel.querySelector('.rt-track-wrapper'), {
          loop: true,
          slidesPerView: 1.15,
          spaceBetween: 16,
          pagination: {
            el: panel.querySelector('[data-pips]'),
            type: 'bullets',
            bulletClass: 'rt-pip',
            bulletActiveClass: 'is-active',
          },
          navigation: {
            nextEl: panel.querySelector('[data-next]'),
            prevEl: panel.querySelector('[data-prev]'),
          },
          breakpoints: {
            1025: {
              slidesPerView: desktopLayout === 'vertical' ? 4 : 3,
              spaceBetween: 24,
            },
          },
        });
      };
  
      requestAnimationFrame(() => {
        initSwiper(panels[0]);
        initialized[0] = true;
      });
  
      tabBtns.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          tabBtns.forEach((b, j) => {
            b.classList.toggle('is-active', j === i);
            b.setAttribute('aria-selected', j === i ? 'true' : 'false');
          });
          panels.forEach((p, j) => p.classList.toggle('is-active', j === i));
  
          if (!initialized[i]) {
            initSwiper(panels[i]);
            initialized[i] = true;
          }
        });
      });
    }
  }
  
  customElements.define('reviews-testimonials', ReviewsTestimonials);